var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifelongLearningandContinuousImprovement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 40.5,
    fill: "#0089E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.375 34.3333C52.0625 34.3333 50.8292 36.4917 51.4459 38.1875L45.8959 43.7375C45.4334 43.5833 44.8167 43.5833 44.3542 43.7375L40.3459 39.7292C40.9625 38.0333 39.7292 35.875 37.4167 35.875C35.2584 35.875 33.8709 38.0333 34.4875 39.7292L27.3959 46.6667C25.7 46.2042 23.5417 47.4375 23.5417 49.75C23.5417 51.4458 24.9292 52.8333 26.625 52.8333C28.7834 52.8333 30.1709 50.675 29.5542 48.9792L36.4917 41.8875C36.9542 42.0417 37.5709 42.0417 38.0334 41.8875L42.0417 45.8958C41.5792 47.4375 42.8125 49.75 45.125 49.75C47.4375 49.75 48.6709 47.5917 48.0542 45.8958L53.6042 40.3458C55.3 40.8083 57.4584 39.575 57.4584 37.4167C57.4584 35.7208 56.0709 34.3333 54.375 34.3333ZM45.125 35.875L46.5125 32.6375L49.75 31.25L46.5125 29.8625L45.125 26.625L43.7375 29.8625L40.5 31.25L43.7375 32.6375L45.125 35.875ZM27.3959 38.9583L28.1667 35.875L31.25 35.1042L28.1667 34.3333L27.3959 31.25L26.625 34.3333L23.5417 35.1042L26.625 35.875L27.3959 38.9583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifelongLearningandContinuousImprovement);
export default __webpack_public_path__ + "static/media/LifelongLearning andContinuousImprovement.3d9f7ea0d061d19bab9243e6eea6785f.svg";
export { ForwardRef as ReactComponent };